import { render, staticRenderFns } from "./StoryWayPoint.vue?vue&type=template&id=43011850&scoped=true"
import script from "./StoryWayPoint.vue?vue&type=script&lang=js"
export * from "./StoryWayPoint.vue?vue&type=script&lang=js"
import style0 from "./StoryWayPoint.vue?vue&type=style&index=0&id=43011850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43011850",
  null
  
)

export default component.exports